<template>
  <div class="internet-modal__bid-panel">
    <div v-if="userId" class="position-relative">
      <transition name="fade" mode="out-in">
        <div
          v-if="this.activeModalLimit.value && isOrderEqualCurrentValue"
          class="alert alert-success position-absolute w-100"
          role="alert"
          v-html="successAlert"
        />
        <div
          class="alert alert-danger position-absolute w-100"
          v-else-if="errors"
          v-html="I18n.t(`internet_auctions.auction.errors.${errors.detail.error}`)"
        />
      </transition>
      <label class="select form-label d-block mb-4">
        {{ I18n.t('internet_auctions.auction.choose_bid') }}
      </label>
      <v-select
        v-model="value"
        class="internet_auction-select mb-3"
        :options="internetAuction.possibleBiddings"
        :placeholder="I18n.t('internet_auctions.auction.choose_bid_amount')"
      >
        <template
          slot="selected-option"
          slot-scope="option"
        >
          {{ generateLabel(option) }}
        </template>
        <template
          slot="option"
          slot-scope="option"
        >
          {{ generateLabel(option) }}
        </template>
        <template slot="no-options">
          {{ I18n.t('internet_auctions.impossible_biddings') }}
        </template>
      </v-select>
      <button
        @click="sendRequest"
        class="btn btn--block btn__primary w-100"
        :disabled="isBidButtonDisabled"
      >
        {{ I18n.t("internet_auctions.bid") }}
      </button>
      <input
        id="create-order"
        v-model="showMaxLimit"
        type="checkbox"
        :disabled="isOrderPresent"
      />
      <label
        class="ml-1 my-4"
        for="create-order"
      >
        {{ I18n.t('internet_auctions.auction.show_my_max_bid_amount') }}
      </label>
      <p>
        <small>
          {{ I18n.t("artworks.accepting_sales_conditions") }}
          <span
            @click="goToBiddingRules"
            class="btn-link link--orange d-l-block d-xl-inline"
          >
            {{ I18n.t("artworks.sales_conditions") }}
          </span>
        </small>
      </p>
    </div>
    <a
      v-else
      class="btn btn--lg btn__default live-events__login"
      :href="new_user_session_path"
     >
      {{ I18n.t("internet_auctions.login_to_bid") }}
    </a>
  </div>
</template>

<script>
  /* global Routes I18n */
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
  import { formatNumber } from '@/shared/helpers';

  export default {
    name: 'BidPanel',
    props: {
      internetAuction: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        new_user_session_path: Routes.new_user_session_path(),
        value: null,
        showMaxLimit: false,
        isRequestInProgress: false,
        biddingRulesTab: 'rules',
        navTabsId: '#navTabs',
      };
    },
    methods: {
      ...mapActions(['createBid', 'createOrder']),
      ...mapMutations([
        'USER_IS_NOT_LAST_BIDDER',
        'REMOVE_ACTIVE_MODAL_INTERNET_AUCTION',
        'SET_ACTIVE_TAB',
      ]),
      async sendRequest() {
        this.isRequestInProgress = true;
        await this.createOrder({
          limit: this.value,
          internetAuctionId: this.internetAuction.id,
          hiddenLimit: !this.showMaxLimit,
        });
        this.showMaxLimit = false;
        this.isRequestInProgress = false;
        this.value = null;
      },
      generateLabel(option) {
        return I18n.t('internet_auctions.auction.bids.price', { price: this.formatPrice(option.label) });
      },
      goToBiddingRules() {
        this.REMOVE_ACTIVE_MODAL_INTERNET_AUCTION();
        this.SET_ACTIVE_TAB(this.biddingRulesTab);
        this.$scrollTo(this.navTabsId, -1);
      },
    },
    watch: {
      userIsLastBidder(newValue) {
        if (!newValue) {
          this.USER_IS_NOT_LAST_BIDDER();
        }
      },
    },
    computed: {
      ...mapState([
        'userId',
        'activeModalLimit',
      ]),
      ...mapGetters(['errors']),
      isOrderPresent() {
        return !!this.internetAuction.internetAuctionOrder;
      },
      userIsLastBidder() {
        return this.internetAuction.lastBidUserId === this.userId;
      },
      isBidButtonDisabled() {
        return this.isRequestInProgress || !this.value;
      },
      successAlert() {
        if (this.activeModalLimit.limit) {
          return I18n.t('internet_auctions.auction.limit_success_html', {
            limit: this.formatPrice(this.activeModalLimit.limit),
            value: this.formatPrice(this.activeModalLimit.value),
          });
        }
        return I18n.t('internet_auctions.auction.success_html', {
          value: this.formatPrice(this.activeModalLimit.value),
        });
      },
      isOrderEqualCurrentValue() {
        return this.activeModalLimit.value === this.internetAuction.value;
      },
    },
    created() {
      this.formatPrice = formatNumber;
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/internet_auctions/components/modal/bid_panel.vue?2bb5c582